import { z } from 'zod';

export const transferClubSchema = z.object({
  email: z
    .string()
    .min(1, { message: 'Debe ingresar un email' })
    .email({ message: 'Debe ingresar un email válido' })
    .max(255, { message: 'El email es demasiado largo' }),
});

export type TransferClubFormData = z.infer<typeof transferClubSchema>;
